// extracted by mini-css-extract-plugin
export default {"logo":"kQHKc8EzUTpnA0YVtHkX"};